import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import TrustedBy from "@/components/site/TrustedBy";
import LearningOutcomes from "@/components/site/LearningOutcomes";
import CoursesIncluded from "@/components/site/CoursesIncluded";
import Packages from "@/components/site/Packages";
import OnePercentClubTeaser from "@/components/site/OnePercentClubTeaser";
import Journey from "@/components/site/Journey";
import SuccessStories from "@/components/site/SuccessStories";
import FAQ from "@/components/site/FAQ";
import CTASection from "@/components/site/CTASection";
import Footer from "@/components/site/Footer";
import StickyCart from "@/components/site/StickyCart";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen w-full max-w-full overflow-x-clip bg-[#F8FAFC] dark:bg-[#020617] text-[#1E293B] dark:text-[#F8FAFC] selection:bg-[#06B6D4]/30"
    >
      <Navigation />
      <Hero />
      <TrustedBy />
      <LearningOutcomes />
      <CoursesIncluded />
      <Packages />
      <OnePercentClubTeaser />
      <Journey />
      <SuccessStories />
      <FAQ />
      <CTASection />
      <Footer />
      <StickyCart />
    </main>
  );
}
